import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class EditOfferService {
    private info: Subject<Number> = new BehaviorSubject<Number>(0);

    get info$() {
        return this.info.asObservable();
    }

    sendOfferID(number: Number) {
        this.info.next(number);
    }

}